import React from 'react';

class MenuItem extends React.Component {
    render () {
        const { children, className, onClick, ...props } = this.props;
        let clickProps = {
            onClick: (e) => {
                onClick && onClick(e);
            },
            onKeyPress: (e) => {
                var code = e.which;
                // 13 = Return, 32 = Space
                if ((code === 13) || (code === 32)) {
                    onClick && onClick(e);
                }
            }
        };
        return (
        <div role="menuitem" tabIndex="0" className={`tde-menu-item ` + (className || '')} {...clickProps} {...props}>
            {children}
        </div>
        )
    }
}

export default MenuItem
